import ReactQuill, { Quill } from "react-quill";
import _ from "lodash";
import "react-quill/dist/quill.snow.css";
import "../../assets/scss/components/commons/TextEditor.scss";
import { createPortal } from "react-dom";
import { CSSProperties, ReactNode, useState } from "react";
import { Placeholder } from "semantic-ui-react";

const { ImageDrop } = require("quill-image-drop-module");
// const ImageCompress = require("quill-image-compress");
// const { ImageResize } = require("quill-image-resize-module");

Quill.register("modules/imageDrop", ImageDrop);
// Quill.register("modules/imageResize", ImageResize);
// Quill.register("modules/imageCompress", ImageCompress);

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["code-block", "image", "link"],

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],

  ["clean"], // remove formatting button
];

export function TextEditor(props: {
  name: string;
  value: string;
  placeholder?: string;
  onChange: (event: any, data: { name: string; value: string }) => void;
}) {
  return (
    <div className="text-editor">
      <ReactQuill
        modules={{
          toolbar: toolbarOptions,
          imageDrop: true,
          //   ImageCompress: {},
          /*  ImageResize: {
            handleStyles: {
              displaySize: true,
              backgroundColor: "black",
              border: "none",
              color: "white",
            },
            modules: ["Resize", "DisplaySize", "Toolbar"],
          }, */
        }}
        placeholder = {props.placeholder}
        theme="snow"
        value={props.value}
        onChange={(value) =>
          props.onChange(null, {
            name: props.name,
            value: value ? value.replace(/^<p><br><\/p>$/, "") : "",
          })
        }
      />
    </div>
  );
}
